export default {"src":"/_next/static/media/apple-store.fa9fe284.svg","height":40,"width":109,"blurWidth":0,"blurHeight":0};